/**
 * Shown by the top-level <Suspense> while a lazy-loaded route chunk is
 * fetched. Kept deliberately dumb: no header, no router hooks — it must be
 * safe to render before any page-level data has loaded.
 */
export default function RouteFallback() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950"
      role="status"
      aria-live="polite"
      aria-label="Загрузка страницы"
    >
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-amber-500 border-t-transparent" />
    </div>
  );
}
